export const removeUnderscore = (text: string): string => text.replace(/_/g, ' ')

export function capitalizeText(inputString: string): string {
    if (!inputString) return ''
    const words = inputString.split('_')
    words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase()
    for (let i = 1; i < words.length; i++) {
        words[i] = words[i].toLowerCase()
    }
    return words.join(' ')
}
